<template>
  <div class="footer" style="overflow: hidden;">
    <div class="con">
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-7">
              <div class="content wow" v-on-scroll="{animation: 'one'}">
                <img src="@/assets/gvLearning/img/Group.png" alt="logo">
                <div class="disc-one">
                  <h3>About us</h3>
                  <p>GV Learning is an online learning community with a wide
                    verity of classes for creative and curious people, including
                    Robotics, Arts, Etiquette, Book Clubs and many more.</p>
                </div>
                <div class="contact">
                  <h3>Contact us</h3>
                  <p>+971 658 2627<br>
                    info@gvc.ae<br>
                    UAE - Abu Dhabi - Khalidya - Al Ahlya Tower</p>
                </div>
              </div>

            </div>
            <div class="col-md-5">
              <div class="content wow" v-on-scroll="{animation: 'two'}">
                <h3>Navigation</h3>
                <ul class="list-unstyled">
                  <li>
                    <a href="#">Offerings</a>
                  </li>
                  <li>
                    <a href="#">Team Plans</a>
                  </li>
                  <li>
                    <a href="#">Refer a friend</a>
                  </li>
                  <li>
                    <a href="#">Limited Memeberships</a>
                  </li>
                  <li>
                    <a href="#">GV Business</a>
                  </li>
                  <li>
                    <a href="#">Become a Teacher</a>
                  </li>
                </ul>
              </div>

            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-5">
              <div class="content wow" v-on-scroll="{animation: 'three'}">
                <h3>Helpful links</h3>
                <ul class="list-unstyled">
                  <li>
                    <a href="#">Global Vision Training and Education Consultancy</a>
                  </li>
                  <li>
                    <a href="#">Global Vision Events Managment</a>
                  </li>
                  <li>
                    <a href="#">GV Stores</a>
                  </li>
                  <li>
                    <a href="#">Portfolio</a>
                  </li>
                  <li>
                    <a href="#">Hire Us</a>
                  </li>
                </ul>
              </div>

            </div>
            <div class="col-md-7">
              <div class="content wow" v-on-scroll="{animation: 'last'}">
                <h3>Newsletter</h3>
                <p>Many things are always happening! Get the latest gvLearnings, promos and events...</p>
                <form>
                  <input type="email" name="email" placeholder="Email">
                  <button class="sign-up">Sign Up</button>
                </form>
                <div class="social">
                  <a class="facebook" href="#">
                    <svg width="9" height="18" viewBox="0 0 9 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M7.17402 2.98875H8.77629V0.12675C8.49986 0.08775 7.54918 0 6.44199 0C4.13183 0 2.5493 1.49025 2.5493 4.22925V6.75H0V9.9495H2.5493V18H5.67486V9.95025H8.12105L8.50937 6.75075H5.67413V4.5465C5.67486 3.62175 5.91765 2.98875 7.17402 2.98875Z"
                          fill="white"/>
                    </svg>
                  </a>
                  <a class="insta" href="#">
                    <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" clip-rule="evenodd"
                            d="M6.2558 1.08243e-06L12.8375 4.92016e-07C15.8662 2.20325e-07 18.3223 2.51887 18.3223 5.625L18.3223 12.375C18.3223 15.4811 15.8662 18 12.8375 18L6.2558 18C3.22712 18 0.771043 15.4811 0.771043 12.375L0.771042 5.625C0.771042 2.51888 3.22712 1.35413e-06 6.2558 1.08243e-06ZM2.41647 12.375C2.41647 14.5462 4.13868 16.3125 6.2558 16.3125L12.8375 16.3125C14.9546 16.3125 16.6768 14.5462 16.6768 12.375L16.6768 5.625C16.6768 3.45375 14.9546 1.6875 12.8375 1.6875L6.2558 1.6875C4.13868 1.6875 2.41647 3.45375 2.41647 5.625L2.41647 12.375ZM9.54579 4.5C11.969 4.5 13.9336 6.51488 13.9336 9C13.9336 11.4851 11.969 13.5 9.54579 13.5C7.12262 13.5 5.15798 11.4851 5.15798 9C5.15798 6.51488 7.12262 4.5 9.54579 4.5ZM9.54579 11.8125C11.0574 11.8125 12.2882 10.5503 12.2882 9C12.2882 7.44863 11.0574 6.1875 9.54579 6.1875C8.03419 6.1875 6.80341 7.44863 6.80341 9C6.80341 10.5503 8.03419 11.8125 9.54579 11.8125ZM4.2467 4.16213C4.2467 4.49329 4.50846 4.76175 4.83136 4.76175C5.15426 4.76175 5.41602 4.49329 5.41602 4.16213C5.41602 3.83096 5.15426 3.5625 4.83136 3.5625C4.50846 3.5625 4.2467 3.83096 4.2467 4.16213Z"
                            fill="white"/>
                    </svg>
                  </a>
                  <a class="twitter" href="#">
                    <svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M19.2625 1.97425C18.5581 2.29118 17.8074 2.50125 17.0248 2.60325C17.8299 2.11025 18.4444 1.33554 18.7333 0.401754C17.9826 0.860754 17.1538 1.18497 16.2705 1.3659C15.5578 0.58754 14.5419 0.105469 13.4337 0.105469C11.2835 0.105469 9.55246 1.89533 9.55246 4.08954C9.55246 4.40525 9.57851 4.70883 9.64245 4.99783C6.41365 4.83633 3.55663 3.24925 1.63735 0.831612C1.30227 1.42783 1.10573 2.11025 1.10573 2.8449C1.10573 4.22433 1.79837 5.44711 2.83083 6.15504C2.20686 6.1429 1.59472 5.95711 1.07613 5.66447C1.07613 5.67661 1.07613 5.6924 1.07613 5.70818C1.07613 7.64375 2.42235 9.25147 4.18771 9.62183C3.87158 9.71047 3.52703 9.75297 3.16946 9.75297C2.92082 9.75297 2.66981 9.7384 2.43419 9.68497C2.93739 11.2623 4.36531 12.422 6.06318 12.4596C4.74183 13.5197 3.06408 14.1584 1.24781 14.1584C0.929309 14.1584 0.623834 14.1438 0.318359 14.1038C2.03873 15.2415 4.07759 15.8912 6.2763 15.8912C13.423 15.8912 17.3302 9.81975 17.3302 4.55704C17.3302 4.38097 17.3243 4.21097 17.316 4.04218C18.0868 3.48118 18.7345 2.78054 19.2625 1.97425Z"
                          fill="white"/>
                    </svg>
                  </a>
                  <a class="youtube" href="#">
                    <svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M18.8117 2.28854C18.5934 1.4494 17.9535 0.78792 17.142 0.561966C15.6596 0.142578 9.72969 0.142578 9.72969 0.142578C9.72969 0.142578 3.80002 0.142578 2.31758 0.546066C1.52172 0.77178 0.866238 1.44952 0.647936 2.28854C0.257812 3.82119 0.257812 6.99972 0.257812 6.99972C0.257812 6.99972 0.257812 10.1943 0.647936 11.7109C0.866469 12.5499 1.50611 13.2114 2.3177 13.4374C3.81563 13.8569 9.72992 13.8569 9.72992 13.8569C9.72992 13.8569 15.6596 13.8569 17.142 13.4534C17.9536 13.2275 18.5934 12.5661 18.8119 11.727C19.2019 10.1943 19.2019 7.01586 19.2019 7.01586C19.2019 7.01586 19.2175 3.82119 18.8117 2.28854ZM7.84174 9.93616V4.06328L12.7727 6.99972L7.84174 9.93616Z"
                          fill="white"/>
                    </svg>
                  </a>
                </div>


              </div>

            </div>
          </div>
        </div>
      </div>
      <hr>

    </div>

    <div class="copyright text-center" v-on-scroll="{animation: 'swing'}">
      <p class="wow">©2022 All rights reserved</p>
    </div>
  </div>
</template>


<style lang="scss" scoped>
@import "~@/assets/gvLearning/styles.scss";

.swing {
  p {
    animation: swing;
    animation-duration: 2s;
  }
}

.footer {
  background: linear-gradient(94.17deg, #003827 -40.66%, #00F781 215.35%);
  box-shadow: 0px 108px 101px -47px rgba(0, 0, 0, 0.1);
  padding: 60px 0 1px 0;

  .con {
    padding: 0 100px;
    @media (min-width: $width1) and (max-width: $width2) {
      padding: 0 18px 22px 18px;
    }

    .one {
      animation: slideInRight;
      animation-duration: 2s;
    }

    .two {
      animation: slideInRight;
      animation-duration: 2s;
    }

    .three {
      animation: slideInLeft;
      animation-duration: 2s;
    }

    .last {
      animation: slideInLeft;
      animation-duration: 2s;
    }

    .content {
      @media (min-width: $width1) and (max-width: $width2) {
        border-bottom: 1px solid rgba(255, 255, 255, 0.4);;
        padding: 42px 0 18px 0;
      }

      .disc-one {
        margin-top: 29px;

        h3 {
          margin-bottom: 2px;
        }
      }

      .contact {
        margin-top: 33px;

        h3 {
          margin-bottom: 2px;
        }
      }

      h3 {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 180.5%;
        /* or 32px */
        color: #FFFFFF;
        margin-bottom: 40px;
        @media (min-width: $width1) and (max-width: $width2) {
          margin-bottom: 18px;
        }
      }

      p {
        font-family: Roboto;
        font-style: normal;
        font-weight: lighter;
        font-size: 15px;
        line-height: 21px;
        color: #FFFFFF;
        opacity: 0.8;
      }

      ul {
        li {
          margin-bottom: 13px;

          a {
            font-family: Roboto;
            font-style: normal;
            font-weight: lighter;
            font-size: 15px;
            /* or 111% */
            color: #FFFFFF;
            opacity: 0.8;
            text-decoration: none;
          }
        }
      }

      form {
        position: relative;
        margin-top: 22px;

        input {
          background: rgba(255, 255, 255, 0.2);
          border: none;
          padding: 16px 32px;
          border-radius: 9px;
          width: 100%;
          @media (min-width: $width1) and (max-width: $width2) {
            padding: 13px 32px;
          }
        }

        button {
          background: #00F781;
          border-radius: 9px;
          color: #FFF;
          border: navajowhite;
          padding: 16px 20px;
          position: absolute;
          top: 0;
          right: 0;
          transition: all 2s;
          @media (min-width: $width1) and (max-width: $width2) {
            padding: 13px 20px;
          }

          &:hover, &:focus {
            background: #003827;
          }

        }
      }

      .social {
        margin-top: 40px;
        @media (min-width: $width1) and (max-width: $width2) {
          margin-top: 22px;
        }

        svg {
          margin-right: 15px;
          margin-right: 22px;
          @media (min-width: $width1) and (max-width: $width2) {
            margin-right: 15px;
            width: 15px;
          }
        }

        .facebook {
          &:hover svg path {
            fill: #003827;
          }
        }

        .insta {
          &:hover svg path {
            fill: #003827;
          }
        }

        .twitter {
          &:hover svg path {
            fill: #003827;
          }
        }

        .youtube {
          &:hover svg path {
            fill: #003827;
          }
        }

      }
    }

    .content.last {
      @media (min-width: $width1) and (max-width: $width2) {
        border: none;
      }
    }

    hr {
      height: 1px;
      background: #FFFFFF;
      animation: flash;
      animation-duration: 2s;
      @media (min-width: $width1) and (max-width: $width2) {
        display: none;
      }

    }

  }

  .copyright {
    p {
      opacity: 0.8;
      font-size: 16px;
      font-family: Roboto;
      font-style: normal;
      color: #FFFFFF;
      line-height: 66px;
      @media (min-width: $width1) and (max-width: $width2) {
        background: linear-gradient(270deg, #131313 -40.25%, #686868 164.47%);
        margin: 0;
      }
    }
  }
}
</style>
